import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PhotoSwipeModule } from '@df/ui/photoswipe/photoswipe.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { Nexus } from '@tomandco/nexus-api-types';
import { CustomCursorComponent } from '../../../../ui/display/custom-cursor/custom-cursor.component';
import { LocalVimeoPlayerComponent } from '../../../../ui/display/media/vimeo-player.component';

@Component({
    selector: 'product-details-carousel',
    templateUrl: './product-details-carousel.html',
    styleUrl: './product-details-carousel.scss',
    standalone: true,
    imports: [
        CommonModule,
        CustomCursorComponent,
        DfImageDirective,
        DfUiCarouselModule,
        LocalVimeoPlayerComponent,
        PhotoSwipeModule,
        SizeClassDirective,
        ShellComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailsCarouselComponent extends UiComponent {
    media = input.required<Nexus.Lib.Catalog.Type.IProductMediaItem[]>();
    product = input.required<Product>();

    loop = computed(() => this.media().length > this.slidesPerViewRound);

    get slidesPerView() {
        return [1.78, 2.53, 2.53, 2.53][this.client.sizeId];
    }

    get slidesPerViewRound() {
        return Math.round(this.slidesPerView);
    }

    get spaceBetween() {
        return [2, 4, 4, 4][this.client.sizeId];
    }
}
